import type { MapSettings } from '../../admin/types';

/** The map-level "Поиск" settings — MapSettingsPage owns the draft (`form`)
 * and the single page-level Save button, same as the "Основные" tab; this
 * component is just the controls for one slice of that draft. */
export function SearchTab({
  search,
  onChange,
}: {
  search: MapSettings['search'];
  onChange: (next: MapSettings['search']) => void;
}) {
  return (
    <div className="px-8 py-6">
      <div className="mx-auto grid max-w-[900px] grid-cols-2 gap-6">
        <section className="rounded-2xl border border-border-default bg-bg-surface p-6">
          <h2 className="text-[15px] font-semibold text-text-primary">Область поиска</h2>
          <p className="mt-1 text-xs text-text-secondary">
            Что ищет строка поиска на этой карте — источники можно включить одновременно.
          </p>

          <div className="mt-4 flex flex-col gap-2">
            <div className="flex items-center justify-between gap-4 rounded-[10px] border border-border-default px-4 py-3">
              <div>
                <p className="text-[13px] font-medium text-text-primary">Объекты</p>
                <p className="mt-0.5 text-[11px] text-text-secondary">Поиск по атрибутам объектов слоёв этой карты</p>
              </div>
              <button
                type="button"
                onClick={() => onChange({ ...search, searchObjects: !search.searchObjects })}
                className={`flex h-[26px] w-[52px] shrink-0 items-center rounded-full px-1 transition-colors ${
                  search.searchObjects ? 'bg-action-primary justify-end' : 'bg-bg-surface-secondary justify-start'
                }`}
              >
                <span className="size-[18px] rounded-full bg-bg-surface shadow" />
              </button>
            </div>

            <div className="flex items-center justify-between gap-4 rounded-[10px] border border-border-default px-4 py-3">
              <div>
                <p className="text-[13px] font-medium text-text-primary">Адреса</p>
                <p className="mt-0.5 text-[11px] text-text-secondary">
                  Поиск по адресам (данные OSM) — в списке результатов адрес помечен отдельно
                </p>
              </div>
              <button
                type="button"
                onClick={() => onChange({ ...search, searchAddresses: !search.searchAddresses })}
                className={`flex h-[26px] w-[52px] shrink-0 items-center rounded-full px-1 transition-colors ${
                  search.searchAddresses ? 'bg-action-primary justify-end' : 'bg-bg-surface-secondary justify-start'
                }`}
              >
                <span className="size-[18px] rounded-full bg-bg-surface shadow" />
              </button>
            </div>
          </div>
        </section>

        <section className="rounded-2xl border border-border-default bg-bg-surface p-6">
          <h2 className="text-[15px] font-semibold text-text-primary">Поведение</h2>

          <label className="mt-4 block text-[11px] font-medium text-text-secondary">
            Минимум символов для начала поиска
          </label>
          <input
            type="number"
            min={1}
            max={10}
            value={search.minQueryLength}
            onChange={(e) => onChange({ ...search, minQueryLength: Number(e.target.value) })}
            className="mt-1.5 h-10 w-full rounded-[9px] border border-border-default bg-bg-surface px-3 text-[11px] text-text-primary outline-none focus:border-action-primary"
          />

          <label className="mt-3 block text-[11px] font-medium text-text-secondary">Максимум результатов</label>
          <input
            type="number"
            min={1}
            max={100}
            value={search.maxResults}
            onChange={(e) => onChange({ ...search, maxResults: Number(e.target.value) })}
            className="mt-1.5 h-10 w-full rounded-[9px] border border-border-default bg-bg-surface px-3 text-[11px] text-text-primary outline-none focus:border-action-primary"
          />

          <div className="mt-4 flex items-center justify-between gap-4">
            <span className="text-[11px] font-medium text-text-secondary">
              Перемещать карту к результату при выборе
            </span>
            <button
              type="button"
              onClick={() => onChange({ ...search, flyToOnSelect: !search.flyToOnSelect })}
              className={`flex h-[26px] w-[52px] shrink-0 items-center rounded-full px-1 transition-colors ${
                search.flyToOnSelect ? 'bg-action-primary justify-end' : 'bg-bg-surface-secondary justify-start'
              }`}
            >
              <span className="size-[18px] rounded-full bg-bg-surface shadow" />
            </button>
          </div>
        </section>
      </div>
    </div>
  );
}
